import { detectWebviewOs } from '../utilities/userAgent'
import {
  disableHeader as androidDisableHeader,
  enableHeader as androidEnableHeader,
  loadUrl as androidLoadUrl,
  requestCredentials as androidRequestCredentials,
} from './android'
import { postMessage } from './ios'
import { IOSNames, OsTypes } from './types'

/*
 * Enables the nav bar header
 */
export const enableHeader = () => {
  switch (detectWebviewOs()) {
    case OsTypes.iOS:
      postMessage({ name: IOSNames.IOS_ENABLE_NAVBAR_HEADER })
      break
    case OsTypes.Android:
      androidEnableHeader()
      break
  }
}

/*
 * Disables the nav bar header
 * Used in places like when submitting and you don't
 * want the user to refresh the page
 */
export const disableHeader = () => {
  switch (detectWebviewOs()) {
    case OsTypes.iOS:
      postMessage({ name: IOSNames.IOS_DISABLE_NAVBAR_HEADER })
      break
    case OsTypes.Android:
      androidDisableHeader()
      break
  }
}

/*
 * iOS:
 * Request credentials from the native client
 * JWT token, unique link, Dasher ID
 *
 * Android:
 * Retrieve credentials from window object
 */
export const requestCredentials = (loadApplication?) => {
  switch (detectWebviewOs()) {
    case OsTypes.iOS:
      postMessage({ name: IOSNames.IOS_REQUEST_CREDENTIALS })
      break
    case OsTypes.Android:
      androidRequestCredentials(loadApplication)
      break
  }
}

/**
 * Loads URLs from inside a webview to another browser window on the device.
 * Android loads the URL after switching to the browser app. iOS loads the URL
 * within the Dasher app without any switching.
 *
 * Why: Webview pages are intended to feel like a seamless part of the
 * native app. Going from webview to webview should feel different than
 * going from webview to external website. External websites should load
 * in their own context to differentiate them from the webviews.
 *
 * Example usages:
 * - From Dasher onboarding webview, go to a USPS tracking page.
 * - From Delivery Issues "Learn more" link, go to our FAQ & help articles.
 *
 * iOS:
 * Load Url by postMessage in an within-dasher-app browser
 *
 * Android:
 * Load Url by androidLoadUrl(theUrl) in a app-switched browser
 */
export const loadUrl = url => {
  switch (detectWebviewOs()) {
    case OsTypes.iOS:
      postMessage({ name: IOSNames.IOS_LOAD_URL, message: url })
      break
    case OsTypes.Android:
      androidLoadUrl(url)
      break
  }
}
